import { CheckCircleTwoTone } from '@mui/icons-material';
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import applePhoto from '../assets/icons/appStoreIcon.svg';
import googlePhoto from '../assets/icons/googleplay.svg';
import { useInApp } from '../hooks/in-app';
import { ISalesIndividualPassport } from '../utils/types';
import PdfViewer from './PdfViewer';

type PassportIdInfoCardProps = {
  passportInfo: ISalesIndividualPassport;
};

export default function PassportIdInfoCard({
  passportInfo,
}: PassportIdInfoCardProps) {
  const { t } = useTranslation();
  const userAgent = navigator.userAgent || navigator.vendor;

  const { inApp } = useInApp();
  const isAndroid = /android/i.test(userAgent);
  const isIOS = /iPad|iPhone|iPod/i.test(userAgent);
  const isWeb = !isAndroid && !isIOS;
  const [pdfOpen, setPdfOpen] = useState(false); // State to control the PDF viewer dialog
  const [pdfUrl, setPdfUrl] = useState<string>(''); // State to hold the URL of the PDF

  const storeLinks = [
    {
      platform: isAndroid || isWeb,
      href: 'https://play.google.com/store/apps/details?id=app.hisarturizm&hl=tr&pli=1',
      imgSrc: googlePhoto,
      alt: 'Google Play Store',
    },
    {
      platform: isIOS || isWeb,
      href: 'https://apps.apple.com/tr/app/hisar-turizm/id1644550663?l=tr',
      imgSrc: applePhoto,
      alt: 'Apple App Store',
    },
  ];

  if (!passportInfo.passportScannerPlatform) {
    return (
      <Box>
        {/*<Typography variant="h5" gutterBottom>*/}
        {/*  {passportInfo.visaType}*/}
        {/*</Typography>*/}

        <Alert sx={{ mb: 2 }} severity="error">
          {t('passportIdInfoCard.notScannedN')}
        </Alert>

        {storeLinks.map(
          (link, index) =>
            !inApp &&
            link.platform && (
              <Button href={link.href} target="_blank" key={index}>
                <img src={link.imgSrc} alt={link.alt} />
              </Button>
            ),
        )}

        {/*{inApp && (*/}
        {/*  <Button*/}
        {/*    sx={{ m: 5 }}*/}
        {/*    color="secondary"*/}
        {/*    variant="contained"*/}
        {/*    href={`hisarapp://navto/passport_reader?orderNumber=${orderNumber}&lastName=${lastName}&sid=${salesIndividualId}`} //TODO*/}
        {/*  >*/}
        {/*    {t('passportIdInfoCard.readPassport')}*/}
        {/*  </Button>*/}
        {/*)}*/}

        {/*<Typography sx={{ color: 'gray' }}>*/}
        {/*  {t('passportIdInfoCard.nfcRequired')}*/}
        {/*</Typography>*/}
      </Box>
    );
  }

  const handleViewVisa = (visaDocFileFullPath: string) => {
    setPdfUrl(visaDocFileFullPath);
    setPdfOpen(true);
  };
  const filePath = passportInfo.passportFrontPhotoFullPath;
  const isPDF = filePath.endsWith('.pdf');

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        {passportInfo.visaType}
      </Typography>

      <Card elevation={2}>
        {!isPDF && (
          <img
            src={passportInfo.passportFrontPhotoFullPath}
            style={{ width: '100%', height: 'calc(100% * 0.64)' }}
          />
        )}
        {isPDF && (
          <Button
            onClick={() =>
              handleViewVisa(passportInfo.passportFrontPhotoFullPath)
            }
          >
            {t('passportInfoCard.viewPassportFile')}
          </Button>
        )}
        <PdfViewer
          open={pdfOpen}
          onClose={() => setPdfOpen(false)}
          pdfUrl={pdfUrl}
        />
        <CardContent>
          <Stack direction="row" spacing={1}>
            <CheckCircleTwoTone color="success" />
            <Typography>
              {t('passportInfoCard.success', {
                visaType: passportInfo.visaType,
              })}
            </Typography>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
